import type { PayloadAction } from '@reduxjs/toolkit';
import type { IProcosState } from '../../../../types';
import { initialState } from './ProcosInitialState';

export const productReducers = {
  setProduct(state: IProcosState, action: PayloadAction<any>): void {
    state.product.name = action.payload.name;
    state.product.id = action.payload.id;
  },
  setProductStatus(state: IProcosState, action: PayloadAction<any>): void {
    state.productStatus = action.payload;
    state.isDataUpdated = true;
    state.isProductStatusUpdated = true;
  },
  resetProductData(state: IProcosState): void {
    state.product = initialState.product;
    state.features = initialState.features;
    state.workItems = [];
  },
};
